// extracted by mini-css-extract-plugin
export default {"container":"UserCard_container__Lh6QY","card":"UserCard_card__uhbCM","label":"UserCard_label__IbrOj","value":"UserCard_value__VHm3x","cardBody":"UserCard_cardBody__ygAxU"};